export default __webpack_public_path__ + "static/media/detail_mobile_15_6.c50b65df.jpg";